$(document).on("_page_ready popin", function () {
	$('.cim_mapbox.info_map').each(function () {
		let $themap = $(this).find('.the_map');
		let map_id = $themap.attr('id');
		
		let latitude = parseFloat($themap.attr('data-latitude'));
		let longitude = parseFloat($themap.attr('data-longitude'));
		
		let sourceType = $themap.attr('data-sourcetype');
		let rootPath = $themap.attr('data-rootpath');
		let configFile = $themap.attr('data-config-file') || 'default';
		let pid = parseInt($themap.attr('data-pid'));
		let uid = parseInt($themap.attr('data-uid'));
		
		let config = {
			el: map_id,
			source: "osm",
			configFile: configFile,
			rootPath: rootPath,
		};
		let map = new CimeosMapbox(config);
		
		if (latitude !== undefined && longitude !== undefined) {
			map.addMarker({
				latitude: latitude,
				longitude: longitude,
				properties: {
					sourceType: sourceType,
					pid: pid,
					uid: uid,
				}
			});
		}
		$(map).on('load', function () {
			map.fitBounds();
		});
		
		if ($('#popin_detail').length) {
			$popinDetail = $('#popin_detail');
			
			$popinDetail.on('open.zf.reveal', function () {
				let update = setInterval(function () {
					if (typeof map.map !== 'undefined' && map.map.loaded()) {
						map.map.resize();
						clearInterval(update);
					}
				}, 100);
			});
			
			$popinDetail.closest('.reveal-overlay').on('scroll', function () {
				let update = setInterval(function () {
					if (typeof map.map !== 'undefined' && map.map.loaded()) {
						map.map.resize();
						clearInterval(update);
					}
				}, 100);
				
			});
		}
	});
});